/*
 * Copyright (c) Dito Technologies LLC
 */

import {graphql} from "babel-plugin-relay/macro";
import {
    ReprocessPieceMutation$data,
    ReprocessPieceMutation$variables
} from "mutation/__generated__/ReprocessPieceMutation.graphql";
import perform from "mutation/perform";

const mutation = graphql`
    mutation ReprocessPieceMutation($input: MusicReprocessPieceInput!) {
        music_reprocess_piece(input: $input) {
            piece {
                id
                ...PieceSettingsBody_piece
            }
        }
    }
`;

export default async function ReprocessPiece(pieceId: string) {
    const variables: ReprocessPieceMutation$variables = {
        input: {
            piece_id: pieceId
        }
    };
    await perform<ReprocessPieceMutation$data>(mutation, variables);
}